// Shared browser-download helpers, extracted from InterviewKitModal /
// services/api so the resume-tailoring downloads reuse the exact same
// behavior.

// Pull `filename` out of a Content-Disposition header. The backend sends the
// RFC 6266 dual form — an ASCII-folded plain `filename="…"` fallback plus the
// RFC 5987 `filename*=UTF-8''…` form carrying the real (possibly non-latin-1,
// e.g. Hebrew) name — so filename* is PREFERRED and percent-decoded, falling
// back to the plain form, then to null so callers can supply their own
// default.
export const parseContentDispositionFilename = (
  contentDisposition: string | null | undefined
): string | null => {
  if (!contentDisposition) return null;
  const star = /filename\*=(?:UTF-8'')?"?([^";]+)"?/i.exec(contentDisposition);
  if (star) {
    try {
      return decodeURIComponent(star[1]);
    } catch {
      return star[1];
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(contentDisposition);
  return plain ? plain[1] : null;
};

// With responseType 'blob', a non-2xx body comes back as a Blob, not JSON — so
// `error.response.data` would be an unreadable Blob. Normalize it back to the
// standard error envelope (in place) so getApiErrorMessage / getApiErrorCode
// can read it, and return the same error for the caller to rethrow:
//   catch (error) { throw await normalizeBlobDownloadError(error); }
// Non-Blob data (already-parsed envelopes, network errors with no response) is
// left untouched; an unparseable Blob body degrades to `data: undefined` so
// readers fall back to status-code defaults.
export const normalizeBlobDownloadError = async (error: any): Promise<any> => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      error.response.data = JSON.parse(await data.text());
    } catch {
      error.response.data = undefined;
    }
  }
  return error;
};

export const triggerBrowserDownload = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // iOS Safari streams the blob after click(); revoking synchronously can
  // abort the transfer. A delayed revoke is harmless elsewhere.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
};
